import React, { ReactComponentElement } from 'react'

import { Container, Content, ModalComponent, SubTitle, Title } from './styles'
import ButtonComp from '../../Button'
import useToast from '../../../hooks/useToast'
import Input from '../../Input'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api'
import { useDirectory } from '../../../store/directory'
import { Row } from '../../commons'
import { FaCircleXmark } from 'react-icons/fa6'
import { ButtonIcon } from '../../Table/Pagination/styles'

export interface ModalHandle {
  openModal: () => void
  closeModal: () => void
}

export interface ModalProps {
  title?: string
  maxWidth?: number
  refetch: () => void
  onOpenModal?: () => void
  children?: ReactComponentElement<any>
}

export interface FileInterface {
  _id: any
  file: File
  name: string
  size: number
}

const ModalCreateFolder: React.ForwardRefRenderFunction<ModalHandle, ModalProps> = (
  { refetch, onOpenModal, maxWidth },
  ref,
) => {
  const [isLoading, setisLoading] = React.useState(false)

  const directory = useDirectory((state) => state.directory)

  const toast = useToast()

  const [open, setOpen] = React.useState(false)

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<{ name: string }>({
    defaultValues: {
      name: '',
    },
  })

  React.useImperativeHandle(ref, () => ({
    openModal() {
      reset()
      setOpen(true)
    },
    closeModal() {
      setOpen(false)
    },
  }))

  const afterOpenModal = () => {
    if (onOpenModal) {
      onOpenModal()
    }
  }

  const handleCreate = async (formData: any) => {
    try {
      setisLoading(true)

      if (formData.name === '') return toast.errorToast('Adicione um nome para pasta!')

      let lastDir = directory[directory.length - 1]

      let payload: any = {
        name: formData.name,
      }
      if (lastDir?.url !== '/') {
        payload.document = lastDir?.url
      }
      await api.post('/documents/folder', payload)

      setOpen(false)
      if (refetch) refetch()
    } catch (error) {
      console.log(error)
    } finally {
      setisLoading(false)
    }
  }

  return (
    <ModalComponent
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={() => setOpen(false)}
      contentLabel='Example Modal'
    >
      <Container>
        <Content maxWidth={maxWidth}>
          <Row justify='space-between'>
            <Title>Criar Pasta</Title>
            <ButtonIcon onClick={() => setOpen(false)}>
              <FaCircleXmark size={25} />
            </ButtonIcon>
          </Row>
          <SubTitle>Uma pasta será criada no caminho atual da página</SubTitle>

          <Input type='text' placeholder='Nome da pasta' name='name' control={control} />

          <ButtonComp
            loading={isLoading}
            color='primary'
            onClick={handleSubmit(handleCreate)}
            variantType='block'
            fullWidth
            label='Criar'
          />
        </Content>
      </Container>
    </ModalComponent>
  )
}

export default React.forwardRef(ModalCreateFolder)
